// src/components/Onboarding.js
import React from 'react';
import './Onboarding.css';
import { useTranslation } from 'react-i18next';

// First-time guided tutorial. Two steps:
// 'intro' - a blocking modal explaining the goal of the level.
// 'hint'  - a small non-blocking callout pointing at the (highlighted) hint
//           button, forcing the player to use their first hint for free.
function Onboarding({ step, theme, onAdvance }) {
  const { t } = useTranslation();

  if (step === 'intro') {
    return (
      <div className="onboarding-backdrop">
        <div className="onboarding-card">
          <h2>{t('onboarding_intro_title')}</h2>
          <p>{t('onboarding_intro_body', { theme })}</p>
          <button className="onboarding-cta" onClick={onAdvance}>
            {t('onboarding_intro_cta')}
          </button>
        </div>
      </div>
    );
  }

  if (step === 'hint') {
    return (
      <>
        {/* Dims + blocks clicks on everything except the hint button, which
            pokes through via a higher z-index (see InputBar.css). */}
        <div className="onboarding-hint-backdrop" />
        <div className="onboarding-hint-callout">
          <p className="onboarding-hint-title">{t('onboarding_hint_title')}</p>
          <p className="onboarding-hint-body">{t('onboarding_hint_body')}</p>
        </div>
      </>
    );
  }

  return null;
}

export default Onboarding;
